export const ALL_BROADCASTS = 'all'
export const LIVE_BROADCASTS = 'live'
export const UPCOMING_BROADCASTS = 'upcoming'
